export const gameCategories = [
  { slug: 'role-playing', name: '角色扮演', icon: 'ri-gamepad-line' },
  { slug: 'strategy', name: '策略战棋', icon: 'ri-compasses-2-line' },
  { slug: 'adventure', name: '冒险解谜', icon: 'ri-compass-3-line' },
  { slug: 'simulation', name: '模拟经营', icon: 'ri-building-2-line' },
  { slug: 'action', name: '动作格斗', icon: 'ri-sword-line' },
  { slug: 'casual', name: '休闲益智', icon: 'ri-lightbulb-line' },
  { slug: 'card', name: '卡牌对战', icon: 'ri-stack-line' },
  { slug: 'mmo', name: '多人联机', icon: 'ri-group-line' },
];

export const games = [
  {
    id: 1,
    title: '幻境奇缘',
    slug: 'huan-jing-qi-yuan',
    category: 'role-playing',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20RPG%20game%20scene%20with%20medieval%20village%20and%20adventurers%2C%20warm%20golden%20lighting%2C%20stylized%20illustration%20style%2C%20soft%20pastel%20background%2C%20minimalist%20game%20art%2C%20clean%20composition%20with%20gentle%20warm%20tones&width=800&height=600&seq=game-01&orientation=landscape',
    description: '一款经典的日式角色扮演黄油网页游戏，丰富的剧情线和精美的角色立绘，让你沉浸在中世纪魔幻世界中。',
    rating: 4.8,
    players: '128,500',
    releaseDate: '2025-12-15',
    featured: true,
  },
  {
    id: 2,
    title: '星际征途',
    slug: 'xing-ji-zheng-tu',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Space%20strategy%20game%20scene%20with%20starships%20and%20galaxy%20map%2C%20warm%20amber%20and%20coral%20accents%2C%20stylized%20illustration%2C%20dark%20background%20with%20nebulae%2C%20clean%20game%20UI%2C%20minimalist%20composition&width=800&height=600&seq=game-02&orientation=landscape',
    description: '科幻题材的策略黄油网页游戏，在浩瀚宇宙中建立你的帝国，征服星系成为宇宙霸主。',
    rating: 4.6,
    players: '96,200',
    releaseDate: '2026-01-20',
    featured: true,
  },
  {
    id: 3,
    title: '魔法学院',
    slug: 'mo-fa-xue-yuan',
    category: 'simulation',
    image: 'https://readdy.ai/api/search-image?query=Magical%20academy%20simulation%20game%20scene%20with%20wizard%20school%20castle%2C%20warm%20golden%20lighting%2C%20stylized%20anime%20illustration%2C%20cozy%20classroom%20interior%2C%20soft%20warm%20color%20palette%2C%20minimalist%20design&width=800&height=600&seq=game-03&orientation=landscape',
    description: '经营一所魔法学院，培养年轻的魔法师，体验教学与冒险的双重乐趣。',
    rating: 4.7,
    players: '85,300',
    releaseDate: '2026-03-08',
    featured: true,
  },
  {
    id: 4,
    title: '地牢探险者',
    slug: 'di-lao-tan-xian-zhe',
    category: 'adventure',
    image: 'https://readdy.ai/api/search-image?query=Dungeon%20exploration%20game%20scene%20with%20torch%20lit%20underground%20ruins%2C%20warm%20amber%20torchlight%2C%20stylized%20illustration%2C%20adventurous%20mood%2C%20soft%20shadow%20details%2C%20minimalist%20dark%20fantasy%20art&width=800&height=600&seq=game-04&orientation=landscape',
    description: '随机生成地牢的冒险黄油网页游戏，每次探险都是全新的挑战与惊喜。',
    rating: 4.5,
    players: '72,100',
    releaseDate: '2026-02-14',
    featured: false,
  },
  {
    id: 5,
    title: '英雄竞技场',
    slug: 'ying-xiong-jing-ji-chang',
    category: 'action',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20arena%20battle%20game%20scene%20with%20warriors%20fighting%2C%20warm%20dramatic%20lighting%2C%20stylized%20illustration%2C%20epic%20colosseum%20background%2C%20soft%20warm%20color%20palette%2C%20dynamic%20composition&width=800&height=600&seq=game-05&orientation=landscape',
    description: '快节奏的动作格斗黄油网页游戏，选择你的英雄在竞技场中一决高下。',
    rating: 4.4,
    players: '63,800',
    releaseDate: '2025-11-30',
    featured: false,
  },
  {
    id: 6,
    title: '梦幻农场',
    slug: 'meng-huan-nong-chang',
    category: 'casual',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20farm%20simulation%20game%20scene%20with%20colorful%20crops%20and%20cute%20animals%2C%20warm%20sunlight%2C%20stylized%20illustration%2C%20peaceful%20countryside%2C%20soft%20pastel%20warm%20colors%2C%20minimalist%20charming%20art&width=800&height=600&seq=game-06&orientation=landscape',
    description: '轻松愉快的模拟经营黄油网页游戏，在田园中种植作物、饲养动物，享受悠闲时光。',
    rating: 4.9,
    players: '156,700',
    releaseDate: '2026-04-01',
    featured: true,
  },
  {
    id: 7,
    title: '龙族传说',
    slug: 'long-zu-chuan-shuo',
    category: 'card',
    image: 'https://readdy.ai/api/search-image?query=Dragon%20card%20battle%20game%20scene%20with%20mythical%20creatures%20and%20magic%20cards%2C%20warm%20mystical%20glow%2C%20stylized%20illustration%2C%20epic%20dragon%20silhouette%2C%20soft%20amber%20and%20gold%20tones%2C%20minimalist%20fantasy%20art&width=800&height=600&seq=game-07&orientation=landscape',
    description: '集换式卡牌对战黄油网页游戏，收集强大的龙族卡牌，组建你的终极卡组。',
    rating: 4.6,
    players: '91,400',
    releaseDate: '2026-01-05',
    featured: false,
  },
  {
    id: 8,
    title: '仙境传说OL',
    slug: 'xian-jing-chuan-shuo-ol',
    category: 'mmo',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20MMO%20game%20scene%20with%20players%20adventuring%20in%20magical%20forest%2C%20warm%20sunlight%20through%20trees%2C%20stylized%20illustration%2C%20vibrant%20world%2C%20soft%20warm%20color%20palette%2C%20grand%20landscape%20composition&width=800&height=600&seq=game-08&orientation=landscape',
    description: '大型多人在线黄油网页游戏，与全球玩家一起探索广阔的奇幻世界。',
    rating: 4.7,
    players: '210,300',
    releaseDate: '2025-10-01',
    featured: true,
  },
  {
    id: 9,
    title: '炼金工坊',
    slug: 'lian-jin-gong-fang',
    category: 'simulation',
    image: 'https://readdy.ai/api/search-image?query=Alchemy%20workshop%20game%20scene%20with%20potions%20and%20magical%20ingredients%2C%20warm%20candlelight%2C%20stylized%20illustration%2C%20cozy%20interior%2C%20soft%20golden%20glow%2C%20minimalist%20charming%20art%20style&width=800&height=600&seq=game-09&orientation=landscape',
    description: '经营一间魔法炼金工坊，收集材料调配神秘药剂，满足顾客的奇幻需求。',
    rating: 4.5,
    players: '58,900',
    releaseDate: '2026-05-12',
    featured: false,
  },
  {
    id: 10,
    title: '时空旅者',
    slug: 'shi-kong-lv-zhe',
    category: 'adventure',
    image: 'https://readdy.ai/api/search-image?query=Time%20travel%20adventure%20game%20scene%20with%20portal%20and%20different%20eras%2C%20warm%20mystical%20lighting%2C%20stylized%20illustration%2C%20clock%20motif%2C%20soft%20amber%20and%20rose%20tones%2C%20dreamy%20composition&width=800&height=600&seq=game-10&orientation=landscape',
    description: '穿越时空的冒险黄油网页游戏，在历史与未来之间穿梭，解开时空之谜。',
    rating: 4.8,
    players: '79,600',
    releaseDate: '2026-06-01',
    featured: false,
  },
  {
    id: 11,
    title: '塔防指挥官',
    slug: 'ta-fang-zhi-hui-guan',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Tower%20defense%20strategy%20game%20scene%20with%20castles%20and%20defense%20lines%2C%20warm%20dramatic%20sunset%20lighting%2C%20stylized%20illustration%2C%20epic%20battlefield%2C%20soft%20warm%20color%20palette%2C%20strategic%20composition&width=800&height=600&seq=game-11&orientation=landscape',
    description: '策略塔防黄油网页游戏，布置防御塔抵御敌人进攻，考验你的战术思维。',
    rating: 4.3,
    players: '67,200',
    releaseDate: '2026-02-28',
    featured: false,
  },
  {
    id: 12,
    title: '欢乐消除',
    slug: 'huan-le-xiao-chu',
    category: 'casual',
    image: 'https://readdy.ai/api/search-image?query=Match%20three%20puzzle%20game%20scene%20with%20colorful%20gems%20and%20cute%20characters%2C%20warm%20cheerful%20lighting%2C%20stylized%20illustration%2C%20bright%20and%20inviting%2C%20soft%20pastel%20warm%20colors%2C%20playful%20composition&width=800&height=600&seq=game-12&orientation=landscape',
    description: '经典三消休闲黄油网页游戏，简单易上手，轻松打发碎片时间。',
    rating: 4.7,
    players: '183,400',
    releaseDate: '2025-09-20',
    featured: true,
  },
];